import { Button } from '@repletoryreach/sdk-ui';
import { downloadText } from '@repletoryreach/sdk-utils/file';
import { notifySuccess } from '@repletoryreach/sdk-ui/notifications';
import type { AuditRow } from '../../../data/useAuditFeed';
import { useTenantMap } from '../../../data/useTenants';
import { useT } from '../../../i18n/I18nProvider';

function escape(value: unknown): string {
  const s = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/**
 * Exports the rows currently on screen.
 *
 * The file leads with the organisation's name, not its id. Somebody opens this
 * in a spreadsheet during an incident review, and a column of GUIDs there is
 * worse than in the console: there is no tenants tab to cross-reference it
 * against. The id follows the name so an engineer can still join on it.
 */
export function ExportCsvButton({ rows }: { rows: AuditRow[] }) {
  const t = useT();
  const { map } = useTenantMap();

  function exportCsv() {
    const headers = ['occurred_at', 'source', 'organisation', 'organisation_id', 'id', 'summary', 'detail'];
    const lines = [headers.join(',')];
    for (const r of rows) {
      const name = map.get(r.organisation_id)?.name ?? '';
      lines.push([r.occurred_at, r.source, name, r.organisation_id, r.id, r.summary, r.detail ?? ''].map(escape).join(','));
    }
    downloadText(lines.join('\n'), `audit-${Date.now()}.csv`, 'text/csv');
    notifySuccess(t('audit.toast.exported', { count: rows.length }), t('audit.toast.exportedTitle'));
  }

  return (
    <Button size="xs" variant="outline" disabled={rows.length === 0} onClick={exportCsv}>
      {t('action.exportCsv')}
    </Button>
  );
}
